import React from 'react';
import { IconType } from 'react-icons';

interface IconProps {
  icon: IconType;
  size?: number;
}

const Icon: React.FC<IconProps> = ({ icon: IconComponent, size = 24 }) => {
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center' }}>
      {IconComponent({ size })}
    </span>
  );
};

export default Icon;